import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as driversActionTypes } from '../../actions/drivers';

export default makeCrudMetaReducer(driversActionTypes);
